export default "__VITE_ASSET__DeHPpBkQ__"